module.exports = __webpack_public_path__ + "img/logo-header.f9ed6804.svg";